import { useEffect, useState } from "react";
import { Menu, X, Zap } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#framework", label: "Approach" },
  { href: "#about", label: "About" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-zinc-950/80 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-7 w-7 items-center justify-center border border-white/15 group-hover:border-violet-400/60 transition-colors">
            <Zap className="h-3.5 w-3.5 text-violet-400" strokeWidth={2.2} />
          </span>
          <span className="font-display text-lg font-semibold tracking-tight text-zinc-50">
            catlyz<span className="text-violet-400">.</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-zinc-400 hover:text-zinc-50 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href="#contact"
            data-testid="nav-cta-book"
            className="inline-flex items-center gap-2 bg-zinc-50 text-zinc-950 px-4 py-2 text-sm font-medium hover:bg-white transition-colors"
          >
            Book an Assessment
            <span className="text-violet-500">→</span>
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          className="md:hidden inline-flex h-9 w-9 items-center justify-center border border-white/10 text-zinc-100"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-white/5 bg-zinc-950/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-zinc-300 text-base"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="mt-2 bg-zinc-50 text-zinc-950 px-4 py-2 text-sm font-medium text-center"
            >
              Book an Assessment
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
